export function UserDisplayName({ user }) {
    var _a, _b, _c;
    const displayName = [(_a = user.spd_data) === null || _a === void 0 ? void 0 : _a.first_name, (_b = user.spd_data) === null || _b === void 0 ? void 0 : _b.last_name].filter(Boolean).join(" ");
    return [displayName !== user.email && displayName, (_c = user.email) !== null && _c !== void 0 ? _c : user.uid].filter(Boolean).join(" ");
}
